<template>
  <VueJsModalPrimary
    v-bind="attrs.modal"
    :name="name"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <template v-if="innerHtml">
        <slot>
          <div v-html="innerHtml" />
        </slot>
      </template>
      <template v-else>
        <slot name="top">
          Unlock
          <span :style="style.functionName">
            {{ functionName }}
          </span>
          with Enterprise plan.
        </slot>
        <slot name="center">
          {{ description }}
          <br>
          <br>
        </slot>
      </template>
      <slot name="bottom">
        Please contact us at
        <LinkPrimary
          :href="href"
          :style="style.email"
        >
          {{ contact }}
        </LinkPrimary>
        for details.
      </slot>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import LinkPrimary from '@modules/v2/link/link-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { CONTACTS, MODAL_WINDOW_NAMES } from '@js/constants'
  import { FontStyle, Layout } from '@js/styles'

  export default {
    name: 'ModalUpgradeEnterpriseWarning',
    components: {
      LinkPrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        contact: CONTACTS.GENERAL_SUPPORT,
        description: '',
        functionName: '',
        innerHtml: null,
        name: MODAL_WINDOW_NAMES.INTRODUCE_ENTERPRISE_LICENSE_PRIMARY,
        attrs: {
          modal: {
            maxWidth: 400,
            height: 'auto',
            width: '90%',
          },
        },
        style: {
          container: {
            padding: `${Layout.space.lg} ${Layout.space.lg}`,
          },
          email: {
            display: 'inline',
          },
          functionName: {
            fontWeight: FontStyle.weight.xl,
          },
        },
      };
    },
    computed: {
      href: function () {
        return `mailto:${this.contact}`;
      },
    },
    methods: {
      beforeOpen: function (e) {
        this.description = e?.params?.description;
        this.functionName = e?.params?.functionName;
        this.innerHtml = e?.params?.innerHtml;
      },
    },
  };
</script>
